import axios from "axios";
import { cloudServiceBaseUrl } from "../../config";

export const OTP_LENGTH = 6;
export const OTP_EXPIRY_MINUTES = 10;
export const OTP_MAX_ATTEMPTS = 5;
export const OTP_RESEND_COOLDOWN_SECONDS = 60;

const OTP_MAIL_TEMPLATE_KEY =
  "2518b.2f361ca8e178de0f.k1.b1095e30-5046-11f1-86c1-9e043fb4688f.19e2b204b93";

const OTP_SUBJECT = "BangDB AppStore OTP Verification";

const randomDigit = () => {
  const buf = new Uint8Array(1);

  do {
    window.crypto.getRandomValues(buf);
  } while (buf[0] >= 250);

  return buf[0] % 10;
};

export const generateOtp = () => Array.from({ length: OTP_LENGTH }, () => randomDigit()).join("");

export const sendOtpEmail = async ({ email, otp }) => {
  const payload = {
    mail_template_key: OTP_MAIL_TEMPLATE_KEY,
    from: {
      address: "no-reply@bangdb.com",
      name: "BangDB NoSQL"
    },
    to: [
      {
        email_address: {
          address: email
        }
      }
    ],
    merge_info: {
      product: "BangDB AppStore",
      OTP: otp,
      valid_time: `${OTP_EXPIRY_MINUTES} minutes`,
      subject: OTP_SUBJECT
    },
    subject: OTP_SUBJECT
  };

  const res = await axios.post(`https://${cloudServiceBaseUrl}/auth/zeptoMail/send_mail`, payload);

  if (res.data?.errcode !== undefined && res.data.errcode !== 0) {
    throw new Error("The mail service could not send the verification code");
  }

  return res.data;
};
